import React, { useEffect, useState } from "react";
import Buttons from "./Buttons";
import { Edit, Exit, AddS } from "./Icons";
import { updateData } from "../functions/firebaseFunctions";

export default function Bullets({ project }) {
    const [editing, setEditing] = useState(false);
    const [bulLoc, setBulLoc] = useState(undefined)
    const updateBullets = event => {
        event.preventDefault()
        const inputs = event.target
        const updatedBulLoc = bulLoc.map((bullet, index) => ({
            ...bullet,
            desc: inputs['bul' + index].value
        }))
        //console.log("updated:", updatedBulLoc)
        updateData(`projects/${project.projectId}/bullets`, updatedBulLoc).then(bulRes => {
            if (bulRes.success) {
                setBulLoc(updatedBulLoc)
                setEditing(false)
            } else {
                console.error(bulRes.message)
            }
        })
    }
    const handleRemove = (index) => {
        //console.log('removing:', index)
        const updatedBulLoc = bulLoc.filter((_, i) => i !== index);
        // Update the state with the new array
        setBulLoc(updatedBulLoc);
    }
    const handleCancel = () => {
        setBulLoc(project?.bullets || [])//reset the local copy to the original state
        setEditing(false)
    }
    const handleAdd = () => {
        const updatedBulLoc = bulLoc.concat({
            key: 'bul' + bulLoc.length,
            desc: "New Bullet"
        });
        setBulLoc(updatedBulLoc)
    }
    useEffect(() => {
        setBulLoc(project?.bullets || [])
    }, [project])
    return (
        <form style={{
            backgroundColor: 'var(--mdGray)',
            borderRadius: 15,
            padding: '5px 15px',
            width: 'fit-content',
        }}
            onSubmit={updateBullets}
        > {/* Bullets */}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5, gap: 10 }}>
                <h2 style={{ textAlign: 'center', color: 'var(--orng)', margin: 0 }}>Bullets</h2>
                {editing ?
                    <Buttons color="orange" cancelAction={handleCancel} inline />
                    : <button className="orangeIconBtn" type="button" onClick={() => { setEditing(true) }}>
                        <Edit />
                    </button>}
            </div>
            <hr style={{ borderColor: 'var(--orng)' }} />
            <ul style={{ display: 'grid' }}>
                {bulLoc && bulLoc.map((bullet, index) =>
                    <li style={{ color: 'white' }} key={bullet.key}>
                        {editing ?
                            <div style={{ display: 'flex' }}>
                                <input
                                    name={'bul' + index}
                                    defaultValue={bullet.desc === "New Bullet" ? undefined : bullet.desc}
                                    className="p"
                                    placeholder={bullet.desc === "New Bullet" ? "New Bullet" : undefined}
                                />
                                <button className="redIconBtn" type='button' onClick={() => { handleRemove(index) }}>
                                    <Exit />
                                </button>
                            </div>
                            : <p>{bullet.desc}</p>
                        }
                    </li>
                )}
                {editing &&
                    <button style={{ placeSelf: 'center' }} type="button" className="orangeIconBtn" onClick={handleAdd}>
                        <AddS />
                    </button>}
            </ul>
        </form>
    )
}